import { HueSaturationFilter } from "../../../operations/filters/hueSaturation.js";
import { GLProgram } from "../../../program.js";
export class HueSaturationProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/hueSaturation/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/hueSaturation/fragment.glsl');
        var result = new HueSaturationProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['hue'] = gl.getUniformLocation(result._program, 'u_hue');
        result._uniforms['saturation'] = gl.getUniformLocation(result._program, 'u_saturation');
        result._uniforms['luminosity'] = gl.getUniformLocation(result._program, 'u_luminosity');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        return result;
    }

    setUniforms(parameters: HueSaturationFilter) {
        var self = this;
        self._gl.uniform2f(self.uniformLocation('texture_size'), parameters._width, parameters._height);
        self._gl.uniform1f(self.uniformLocation('hue'), parameters.hue / parameters.maxHue / 2.0);
        self._gl.uniform1f(self.uniformLocation('saturation'), parameters.saturation / parameters.maxSaturation);
        self._gl.uniform1f(self.uniformLocation('luminosity'), parameters.luminosity / parameters.maxLuminosity);
    }

}